import WR1 from "../../assets/W1.png";
import WR2 from "../../assets/W2.png";
import WR3 from "../../assets/W3.png";
import WR4 from "../../assets/W4.png";

const Data = [
  {
    id: 1,
    img: WR1,
    title: "Landing Page For Company",
    time: "2 Days",
    price: "10 Dollar",
  },
  {
    id: 2,
    img: WR2,
    title: "Recording Data",
    time: "4 Days",
    price: "15 Dollar",
  },
  {
    id: 3,
    img: WR3,
    title: "Landing Page For Personal",
    time: "4 Days",
    price: "5 Dollar",
  },
  {
    id: 4,
    img: WR4,
    title: "API With Wikipedia",
    time: "2 Days",
    price: "10 Dollar",
  },
];
export default Data;
